import { Component, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { faCog, faTimes,faCogs } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-settings-panel',
  templateUrl: './settings-panel.component.html',
  styleUrls: ['./settings-panel.component.scss'],
  animations: [
    trigger('slideInFromTop', [
      state('closed', style({
        transform: 'translateY(-100%)',
        opacity: 0
      })),
      state('open', style({
        transform: 'translateY(0)',
        opacity: 1
      })),
      transition('closed => open', [
        animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')
      ]),
      transition('open => closed', [
        animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)')
      ])
    ])
  ]
})
export class SettingsPanelComponent {
  @Input() isOpen: boolean = false;
  @Output() closePanel = new EventEmitter<void>();

  // Icone FontAwesome
  faCog = faCog;
  faTimes = faTimes;
  faCogs = faCogs;
  onClose() {
    this.closePanel.emit();
  }

  onBackdropClick() {
    this.onClose();
  }

  onPanelClick(event: Event) {
    // Previene la chiusura quando si clicca sul pannello stesso
    event.stopPropagation();
  }
}
